import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, ShieldCheck } from 'lucide-react';
export function SolutionIntro() {
  return <section className="py-12 px-4 bg-brand-black text-white text-center border-y border-white/5" data-id="element-171">
      <div className="max-w-4xl mx-auto" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-173">
          <ShieldCheck className="w-16 h-16 text-brand-green mx-auto mb-6" data-id="element-174" />
          <h2 className="font-display text-4xl md:text-5xl uppercase mb-6" data-id="element-175">
            La solución <span className="text-brand-green" data-id="element-176">definitiva</span>
          </h2>
          <p className="font-body text-xl text-gray-300 mb-12" data-id="element-177">
            Te presentamos{' '}
            <strong className="text-white" data-id="element-178">Padel Zurdo Pro</strong>: el único
            sistema paso a paso que te enseña a jugar, pensar y ganar como un
            verdadero zurdo.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16" data-id="element-179">
            <div className="flex flex-col items-center" data-id="element-180">
              <div className="bg-brand-green/15 p-4 rounded-full mb-4 border border-brand-green/30" data-id="element-181">
                <BookOpen className="w-10 h-10 text-brand-green" data-id="element-182" />
              </div>
              <span className="font-display text-2xl" data-id="element-183">6 TOMOS</span>
              <span className="font-body text-gray-400" data-id="element-184">Completos</span>
            </div>
            <div className="hidden md:block w-px h-20 bg-white/10" data-id="element-185"></div>
            <div className="flex flex-col items-center" data-id="element-186">
              <div className="bg-brand-green/15 p-4 rounded-full mb-4 border border-brand-green/30" data-id="element-187">
                <Gift className="w-10 h-10 text-brand-green" data-id="element-188" />
              </div>
              <span className="font-display text-2xl" data-id="element-189">3 BONOS</span>
              <span className="font-body text-gray-400" data-id="element-190">Exclusivos</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}